module.exports = __webpack_public_path__ + "static/media/apex-logo.5f8e6bc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/apex-logo.svg
// module id = 2427
// module chunks = 0